export default "__VITE_ASSET__31817f57__"